/* eslint-disable import/no-cycle */
import React from 'react';
import { GetStaticProps } from 'next';
import WithPage from '../HOC/Page/WithPage';
import { getMessageData, TMessagesData } from '../models/Message/api';
import MainLayout from '../layout/MainLayout';
import { getSiteData } from '../models/Contentful';
import type { Page } from '../models/Contentful/types';
import { DefaultPage, IStaticPageProps } from '../models/Contentful/types';
import { LayoutPage } from '../types/page';
import ForgotPasswordForm from '../components/Auth/ForgotPasswordForm';

interface IForgotPasswordProps {
  messages: TMessagesData;
}

const ForgotPassword: LayoutPage<IStaticPageProps<IForgotPasswordProps>> = ({ page }) => {
  return (
    <div>
      <div>
        <main>
          <ForgotPasswordForm messages={page.messages} />
        </main>
      </div>
    </div>
  );
};

export default WithPage(ForgotPassword);

ForgotPassword.getLayout = function getLayout(
  page: React.ReactElement,
  props: IStaticPageProps<DefaultPage>,
) {
  return <MainLayout {...props}>{page}</MainLayout>;
};

export const getStaticProps: GetStaticProps<IStaticPageProps<IForgotPasswordProps>> = async () => {
  const siteData = await getSiteData();
  const messages = await getMessageData(['Forgot Password - Check Email']);
  return {
    props: {
      site: siteData.site,
      page: { messages } as Page & IForgotPasswordProps,
    },
  };
};
